webpackJsonp([138622236692534],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/adamwagner/Programming/adamwagner.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/sounds-just-like.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Section = __webpack_require__("./src/components/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ProjectDetail = __webpack_require__("./src/components/ProjectDetail.js");
	
	var _ProjectDetail2 = _interopRequireDefault(_ProjectDetail);
	
	var _Grid = __webpack_require__("./src/components/Grid.js");
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _GridItem = __webpack_require__("./src/components/GridItem.js");
	
	var _GridItem2 = _interopRequireDefault(_GridItem);
	
	var _List = __webpack_require__("./src/components/List.js");
	
	var _List2 = _interopRequireDefault(_List);
	
	var _vars = __webpack_require__("./src/styles/vars.json");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SoundsJustLike = function (_React$Component) {
	  _inherits(SoundsJustLike, _React$Component);
	
	  function SoundsJustLike() {
	    _classCallCheck(this, SoundsJustLike);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SoundsJustLike.prototype.render = function render() {
	    return _react2.default.createElement(
	      _ProjectDetail2.default,
	      { projectName: "sounds-just-like" },
	      _react2.default.createElement(
	        "div",
	        { ref: "content" },
	        _react2.default.createElement(
	          _Section2.default,
	          { reverseDark: true },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftThree: true },
	              _react2.default.createElement(
	                "h1",
	                { style: { WebkitFontSmoothing: 'antialiased' } },
	                "Coming soon."
	              )
	            ),
	            _react2.default.createElement("div", {
	              style: {
	                gridColumn: "1 / span 2",
	                height: "6.666px",
	                background: _vars.colors.asphalt,
	                opacity: 0.8
	              }
	            }),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile overview" },
	              _react2.default.createElement(
	                "p",
	                {
	                  className: "projectSectionMarker",
	                  style: { textAlign: "left" }
	                },
	                "Overview"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true, style: { marginBottom: "1.5em" } },
	              _react2.default.createElement(
	                "p",
	                null,
	                "I started ",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "Sounds Just Like"
	                ),
	                " as a simple WordPress blog in 2009 off a suggestion from my first boss. He noticed I maintained a list of songs that sounded like other songs, and said \u201CYou should publish that online\u201D."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The first version of the site had a meager twenty posts. Traffic, however, was promising \u2014 linear growth to 20,000 unique visitors a month within a year, entirely from organic search. ",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "Sounds Just Like"
	                ),
	                " was scratching an itch."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "In 2013, YouTube sensation VSauce published \u201CWill we ever run out of music\u201D \u2014 an investigation into the uncanny similarites among songs. Traffic exploded, topping 8 million unique visitors in two weeks following the video."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The deluge of traffic also spiked soundalike suggestions from visitors. I recieved 40,000 suggestions of soundalikes via email during this period."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "From late 2013 to 2014, I rebuilt ",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "Sounds Just Like"
	                ),
	                " in Python as a true user-generated-content site. In late 2014, I sold ",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "Sounds Just Like"
	                ),
	                " to ",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "H1tcher"
	                ),
	                ", an NYC-based project with similar goals."
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { rightOne: true, className: "hideMobile projectDetails" },
	              _react2.default.createElement(_List2.default, { title: "Company", items: ["Sounds Just Like"] }),
	              _react2.default.createElement(_List2.default, { title: "Role", items: ["Founder", "Product design", "Development", "Content"] })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return SoundsJustLike;
	}(_react2.default.Component);
	
	exports.default = SoundsJustLike;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sounds-just-like-js-e2b25fa49886a3457b26.js